import api from "@/modules/user/services/user";

const state = () => ({
    users:[],
    apiRslt: {
        fetch: {
            inProgress: false,
            success: false,
            error: false,
        }
    }
})

const getters = {
}

const actions = {
    loadUsers({commit}) {
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.getUsers().then(result => {
            commit('SET_API_DATA_FETCH_SUCCESS')
            commit('SAVE_USER', result.data);
        }).catch(error => {
            throw new Error(`API ${error}`);
        });
    },
    addUser ({ commit, dispatch }, payload) {
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        if (!payload) {
            return
        }
        api.postUser(payload)
            .then((r)=>{
                dispatch('sendFirstPassword',{ id: r.data.id })
                commit('ADD_USER',r.data)
                commit('SET_API_DATA_FETCH_SUCCESS')
                dispatch('notifications/postToChannel', { code: 'VALIDNOTIFICATION002', extra: 'utilisateur' },{ root: true })
            })
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR', e)
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION002', extra: 'utilisateur' },{ root:true })
            })
    },
    sendFirstPassword({ commit },payload){
        api.resetPwd(payload)
            .then(() => {
                commit('SET_API_DATA_FETCH_SUCCESS')
            })
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR',e)
            });
    },
    updateUser({ commit,dispatch }, payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.putUser(payload.id, payload)
            .then((r) => {
                commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                commit('UPDATE_USER', r.data);
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION001', extra: 'utilisateur' },{ root:true })
            })
            .catch((e) => {
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION001', extra: 'utilisateur' },{ root:true })
                commit('SET_API_DATA_FETCH_ERROR', e)
            });
    },
    deleteUser({ commit,dispatch }, id){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.deleteUser(id)
            .then((r) => {
                commit('SET_API_DATA_FETCH_SUCCESS',r.data)
                commit('DELETE_USER',id)
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION003', extra: 'utilisateur' },{ root:true })
            })
            .catch((e) => {
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION003', extra: 'utilisateur' },{ root:true })
                commit('SET_API_DATA_FETCH_ERROR', e)
            })
    }
}

const mutations = {
    ADD_USER (state,payload) {
        state.users.push(payload)
    },
    UPDATE_USER (state,payload){
        state.users = state.users.map(category => {
            if (category.id === payload.id) {
                return Object.assign({}, category, payload.data)
            }
            return category
        })
    },
    DELETE_USER (state, id){
        const index = state.users.findIndex(c => c.id === id);
        state.users.splice(index, 1);
    },
    SAVE_USER(state, payload) {
        state.users = payload;
    },
    SET_API_DATA_FETCH_IN_PROGRESS: (state) => {
        state.apiRslt.fetch.inProgress = true
        state.apiRslt.fetch.completed = false
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_SUCCESS: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = true
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_ERROR: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = true
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
